<ng-template #templateRef>
  <form #editorForm="ngForm" id="documentEditor" name="editDocument">
    <mat-icon *ngIf="Copy.Source" matTooltip="{{'Source: ' + Copy.Source}}" style="float: right;">info</mat-icon>
    <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon>

    <ng-container *ngIf="Copy.TrackAndTrace && Copy.TrackAndTrace.length">
      <button (click)="_Global.openURL(code, '_blank')" *ngFor="let code of Copy.TrackAndTrace"
              mat-icon-button
              matTooltip="Track & Trace {{code}}"
              style="float: right;"
              type="button">
        <mat-icon>local_shipping</mat-icon>
      </button>
    </ng-container>
    <h2 mat-dialog-title>{{Copy.Type?.Title ? Copy.Type?.Title : 'Document'}} {{Copy.Id ? Copy.Number + ' edit' : 'create'}}</h2>
    <ng-container *ngIf="Copy && !Copy.Type">
      <mat-dialog-content>
        <mat-form-field>
          <mat-label>Choose a document type</mat-label>
          <mat-select #selectedType>
            <mat-option *ngFor="let type of _Global.Division?.DocumentTypes" [value]="type">{{type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="fill-remaining-space"></div>
        <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
        <button (click)="Copy.Type = selectedType.value" [disabled]="!selectedType.value" color="primary"
                mat-button
                mat-raised-button>Next
        </button>
      </mat-dialog-actions>
    </ng-container>
    <ng-container *ngIf="Copy && Copy.Type">
      <mat-dialog-content>

        <!-- temporary msgbox -->
        <div *ngIf="DeliverDates && ShowDeliveryDebugMsg" class="col-12">
          <p [innerHTML]="DeliverDates.debugMessage.join('<br>')" class="p-3 w-100 bg-info msgbox" style="font-size: 0.8em;"></p>
        </div>

        <!-- Msgbox -->
        <div *ngIf="showFocMessage()" class="col-12">
          <p (click)="switchToFoc()" class="p-3 w-100 bg-warning msgbox">
            Your order seems to have a value of 0. Are you sure this is not a <strong>free of charge</strong> order?
            Click here to change this order into a free of charge order.</p>
        </div>

        <!--packaging type warning msgbox-->
        <div class="col-12" *ngIf="checkPackaging().length > 0">
          <p class="p-3 w-100 bg-warning msgbox">
            You ordered <b>individual packaged articles</b>, are you sure you want to proceed? Please check following articles: <b>{{checkPackaging().join(', ')}}</b></p>
        </div>

        <!-- Header -->
        <div class="row">
          <div class="col-md-4">
            <!-- Relation swap -->
            <app-relation-selector (ngModelChange)="setRelation($event)"
                                   *ngIf="Copy.Type.Id !== 'a717f747-641d-49b4-826e-e13f0d846291'" [filter]="{where: {IsBlocked: false}, include: _Relation.WithoutGoogleMapsInclude}" [ngModel]="Copy.Relation" name="Relation"
                                   required></app-relation-selector>
          </div>
          <div class="col-md-2">
            <app-dropdown-option [(ngModel)]="Copy.Currency" disabled discriminator="Currency"
                                 model="Document" name="Currency"
                                 placeholder="Currency"></app-dropdown-option>
          </div>
          <div class="col-md-2">
            <!-- Account swap -->
            <app-account-selector [(ngModel)]="Copy.Account" name="Account" required></app-account-selector>
          </div>

          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Document date</mat-label>
              <input [(ngModel)]="Copy.Date" [matDatepicker]="picker1" disabled
                     matInput name="Date"
                     required>
              <mat-datepicker-toggle [for]="picker1" matIconSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker1 [startAt]="Copy.Date "></mat-datepicker>
            </mat-form-field>
          </div>
        </div>


        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <mat-label>Address</mat-label>
              <input (ngModelChange)="filterAddresses($event)" [formControl]="AddressControl" [matAutocomplete]="auto" [ngModel]="Copy.Address" autocomplete="off" matInput name="Address" required type="text">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let address of FilteredAddresses" [disabled]="address.Type?.Id !== '4870f240-1c60-46a2-af41-1b135e46b1ee'"
                            [value]="address" style="line-height: normal;">
                  <ng-container *ngIf="address.Name">{{address.Name}} -</ng-container>
                  {{address.Street}} {{address.Number}} {{address.BusNumber}} | {{address.Type?.Value}}<br>
                  {{address.City}} {{address.Postcode}} {{address.Country?.Name}}
                </mat-option>
                <mat-option (click)="aEditor.edit({Relation: Copy.Relation})" *ngIf="Copy.Relation">
                  <mat-icon>add</mat-icon>
                  Add Address
                </mat-option>
              </mat-autocomplete>
              <mat-icon *ngIf="Copy.Address && !Copy.Address.ExternalId" matTextSuffix matTooltip="This address is not linked with SAP S4!">{{'warning'}}</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Contact person</mat-label>
              <mat-select [(ngModel)]="Copy.Contact" [compareWith]="compareWith" name="Contact">
                <ng-container *ngIf="Copy.Relation">
                  <mat-option *ngFor="let contact of Copy.Relation.Contacts"
                              [value]="contact">
                    {{contact.Fullname}}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="Copy.Type?.Id !== 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <mat-form-field>
              <mat-label>Document Expiration date</mat-label>
              <input [(ngModel)]="Copy.DueDate" [matDatepicker]="picker2" matInput
                     name="DueDate">
              <mat-datepicker-toggle [for]="picker2" matIconSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker2 [startAt]="Copy.DueDate "></mat-datepicker>
            </mat-form-field>
          </div>
          <div [class.col-md-4]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <mat-form-field>
              <mat-label>Delivery date</mat-label>
              <input [(ngModel)]="Copy.DeliveryDate" [matDatepicker]="picker3" [min]="getMinDeliveryDate()" required
                     [matDatepickerFilter]="dateFilter" matInput name="DeliveryDate">
              <mat-datepicker-toggle [for]="picker3" matIconSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker3 [startAt]="Copy.DeliveryDate "></mat-datepicker>
              <mat-hint>Starting from {{getMinDeliveryDate() | date: 'shortDate'}}</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div [class.col-md-3]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <mat-form-field>
              <mat-label>Reference</mat-label>
              <input [(ngModel)]="Copy.Reference" matInput maxlength="35" name="Reference"
                     placeholder="External reference like PO number">
            </mat-form-field>
          </div>
          <div [class.col-md-3]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <app-dropdown-option [(ngModel)]="Copy.Status" [required]="true" discriminator="Status" model="Document"
                                 name="Status" placeholder="Status"></app-dropdown-option>
          </div>
          <div [class.col-md-3]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <app-dropdown-option [(ngModel)]="Copy.DiscountReason" discriminator="DiscountReason" model="Document"
                                 [filterWhere]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa' ? SalesOrderFilter : null"
                                 [required]="Copy.Type?.Id === 'd5cc4fd9-1801-4527-81e1-b9de93076dab'"
                                 [blancoOption]="true" name="DiscountReason" placeholder="Order Reason"></app-dropdown-option>
          </div>
          <div [class.col-md-3]="Copy.Type?.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'" class="col-md-2">
            <app-dropdown-option [(ngModel)]="Copy.SupplyPlant" discriminator="SupplyPlant" model="Address" name="SupplyPlant"
                                 (ngModelChange)="getLeadTime()" placeholder="SupplyingPlant" required></app-dropdown-option>
          </div>
          <ng-container *ngIf="Copy.Type?.Id !== 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'">
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Payment reference</mat-label>
                <input [(ngModel)]="Copy.PaymentRef" matInput name="PaymentRef">
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <app-dropdown-option [(ngModel)]="Copy.PaymentMethod" discriminator="PaymentMethod"
                                   model="Document"
                                   name="Betalingsmethode" placeholder="Payment Method"></app-dropdown-option>
            </div>
          </ng-container>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field>
              <mat-label>External remarks</mat-label>
              <input [(ngModel)]="Copy.Extrem" matInput name="Extrem">
            </mat-form-field>
          </div>
        </div>

        <!--Only needed for Shopify/Trial Boxes-->
        <div *ngIf="Copy.Type?.Id === 'abcdb5fc-5a65-2269-b27c-3202a61fedfb' || Copy.Type?.Id === 'ba90b7f1-99ac-cf61-a38d-411ab62fdefa'" class="row">
          <div class="col-md-12">
            <app-dropdown-option [(ngModel)]="Copy.ShippingMethod" discriminator="ShippingMethod"
                                 model="Document" name="ShippingMethod" placeholder="Shipping Method"></app-dropdown-option>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
              <div data-mdb-perfect-scrollbar='true' class="overflow-auto">
                <table class="mat-mdc-table smallpadding" style="width: 100%; min-width: 1180px;">
                  <tr>
                    <th width="200" style="width: 300px;">Article Code</th>
                    <th width="400" style="min-width: 400px">Description</th>
                    <th width="140" style="width: 140px; min-width: 140px;">
                      Ordered<br/>
                      <mat-icon (click)="updateLinesAsBulk('Ordered');" class="bulk-update">text_rotate_vertical</mat-icon>
                    </th>
                    <th width="100" style="width: 150px;">Unit Price</th>
                    <th width="90" style="width: 90px;">
                      Discount<br/>
                      <mat-icon (click)="updateLinesAsBulk('Discount');" class="bulk-update">text_rotate_vertical</mat-icon>
                    </th>
                    <th width="200" style="width: 200px;">
                      Discount reason<br/>
                      <mat-icon (click)="updateLinesAsBulk('DiscountReason');" class="bulk-update">text_rotate_vertical</mat-icon>
                    </th>
                    <th width="90" style="width: 90px;">Total</th>
                    <th width="200" style="width: 200px;">
                    </th>
                  </tr>
                  <ng-container *ngIf="Copy.DocumentLines">
                    <tr #ngGroup="ngModelGroup"
                        *ngFor="let row of Copy.DocumentLines; let i = index;"
                        [ngModelGroup]="row.randomNumber">
                      <td>
                        <app-article-selector (ngModelChange)="setArticle($event, row)" [disabled]="true" [ngModel]="row.Article"
                                              name="Article"></app-article-selector>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Description</mat-label>
                          <input [(ngModel)]="row.Description" disabled matInput name="Description"
                                 required>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field class="ordered-field">
                          <mat-label>Ordered</mat-label>
                          <input (blur)="onBlur($event, row.Article)" [(ngModel)]="row.Ordered" [step]="row.Article?.Step || 1" [validation]="row.Ordered === 0" errorValidator
                                 matInput name="Ordered"
                                 required type="number">
                          <span matTextSuffix>{{row.Unit?.Value}}</span>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Unit price</mat-label>
                          <input [(ngModel)]="row.UnitPrice" disabled matInput name="UnitPrice"
                                 required step="0.01" type="number">
                          <span matTextSuffix class="suffix-container">
                            <span>{{Copy.Currency?.FreeTextField1}}</span>
                            <span>{{row.Unit ? '/' + row.Unit?.Value : ''}}</span>
                          </span>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Discount</mat-label>
                          <input (ngModelChange)="row.Discount = $event / 100; row.DiscountReason = $event === 0 ? null : row.DiscountReason"
                                 [ngModel]="round(row.Discount)"
                                 [disabled]="row.Article?.Category1?.Id === '4a15e144-da25-43c6-b7a4-8663012baf53'"
                                 matInput min="0" type="number" name="Discount" required>
                          <span matTextSuffix style="padding-right: 8px;">%</span>
                        </mat-form-field>
                      </td>
                      <td>
                        <app-dropdown-option [(ngModel)]="row.DiscountReason"
                                             [disabled]="row.Article?.Category1?.Id === '4a15e144-da25-43c6-b7a4-8663012baf53' || !row.Discount"
                                             [blancoOption]="true"
                                             discriminator="DiscountReason" model="DocumentLine" name="DiscountReason" placeholder="Reason"></app-dropdown-option>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>ex. VAT</mat-label>
                          <input disabled
                                 matInput
                                 value="{{(row.Ordered * (1 - row.Discount)) * row.UnitPrice | number:'1.2-4'}}">
                          <span matTextSuffix>{{Copy.Currency?.FreeTextField1}}</span>
                        </mat-form-field>
                      </td>
                      <td class="text-end">
                        <div class="d-flex justify-content-end gap-2">
                          <button *ngIf="getDeliveryDate(row)" mat-icon-button matTooltip="Available from {{getDeliveryDate(row) | date: 'shortDate'}}" type="button">
                            <mat-icon class="text-warning">warning</mat-icon>
                          </button>
                          <button (click)="duplicate(i)" mat-icon-button type="button">
                            <mat-icon>file_copy</mat-icon>
                          </button>
                          <button (click)="switchRow(i, i - 1)" *ngIf="i > 0" mat-icon-button type="button">
                            <mat-icon>arrow_upward</mat-icon>
                          </button>
                          <button (click)="switchRow(i, i + 1)" *ngIf="i < Copy.DocumentLines.length - 1" mat-icon-button
                                  type="button">
                            <mat-icon>arrow_downward</mat-icon>
                          </button>
                          <button (click)="removeLine(row)" mat-icon-button type="button">
                            <mat-icon>delete</mat-icon>
                          </button>
                          <button *ngIf="row.Promotion" mat-icon-button matTooltip="{{row.Promotion.getTitle()}}: {{row.Promotion.StartDate | date:'shortDate'}} - {{row.Promotion.EndDate | date:'shortDate'}}"
                                  type="button">
                            <mat-icon>local_parking</mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  <tr>
                    <td>
                      <button (click)="articlePicker.open()" mat-icon-button type="button">
                        <mat-icon>add</mat-icon>
                      </button>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <mat-form-field>
                        <mat-label>ex. VAT</mat-label>
                        <input disabled matInput
                               value="{{Total.tot_ex_vat | number:'1.2-4'}}">
                        <span matTextSuffix style="padding-right: 8px;">{{Copy.Currency?.FreeTextField1}}</span>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field>
                        <mat-label>VAT</mat-label>
                        <input disabled matInput
                               value="{{Total.tot_vat | number:'1.2-4'}}">
                        <span matTextSuffix style="padding-right: 8px;">{{Copy.Currency?.FreeTextField1}}</span>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field>
                        <mat-label>incl. VAT</mat-label>
                        <input disabled matInput value="{{Total.tot_incl_vat | number:'1.2-4'}}">
                        <span matTextSuffix style="padding-right: 8px;">{{Copy.Currency?.FreeTextField1}}</span>
                      </mat-form-field>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
          </div>
        </div>
        <div *ngIf=" Copy.Status?.Id === '4b78a670-de3d-4cec-980d-92ba569ef7a0' && Copy.Type.Id === 'cbaab5fc-50e5-4969-b27c-6c02a6bfe3fa'"
             class="row">
          <div class="col-sm-12">
            <mat-checkbox [(ngModel)]="sendMail"
                          name="NotifyEmailOnApprove">
              Notify customer on <strong>{{Copy.Contact?.Email}}</strong>
              (This customer has been e-mailed
              on {{Original.NotifyEmailOnApprove | date:'longDate'}})
            </mat-checkbox>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button [matMenuTriggerFor]="actions" mat-button mat-raised-button type="button">
          <mat-icon>settings</mat-icon>
          Actions
        </button>
        <mat-menu #actions="matMenu">
          <button (click)="ShowDeliveryDebugMsg = !ShowDeliveryDebugMsg" mat-menu-item type="button">
            {{ShowDeliveryDebugMsg ? 'Hide' : 'Show'}} delivery date explanation
          </button>
          <button (click)="calculateShipping()" [disabled]="Copy.Type?.Id === 'd5cc4fd9-1801-4527-81e1-b9de93076dab'" mat-menu-item type="button">
            Calculate Shipping
          </button>
          <button (click)="articlePicker.open()" mat-menu-item type="button">
            Add Articles
          </button>
          <button (click)="pushToSAP()" *ngIf="Copy.Id && _Global.hasGUIPermission('ExactOnline')" mat-menu-item
                  type="button">
            Push to SAP S4
          </button>
          <button (click)="importWizard.edit()" mat-menu-item type="button">
            Import from excell
          </button>
          <button [matMenuTriggerFor]="localstorage" mat-menu-item type="button">
            Local Storage
          </button>
        </mat-menu>

        <mat-menu #localstorage="matMenu">
          <button (confirm)="saveLocal()" appConfirmDialog mat-menu-item message="Save current document content and delete your local storage data? (if there is any)"
                  title="Confirm local storage saving?"
                  type="button">
            Save
          </button>
          <button (confirm)="loadLocal()" [disabled]="!getLocal()" appConfirmDialog mat-menu-item
                  title="Confirm local storage loading?"
                  message="Delete current document content and input your local storage data that was created on {{getLocal()?.Date ? '(' + (getLocal()?.Date | date:'short') + ')' : ''}}?"
                  type="button">
            Load
            {{getLocal()?.Date ? '(' + (getLocal()?.Date | date:'short') + ')' : ''}}
          </button>
          <button (confirm)="deleteLocal()" [disabled]="!getLocal()" appConfirmDialog mat-menu-item
                  title="Confirm local storage deleting?"
                  message="Delete your local storage data, created on {{getLocal()?.Date ? '(' + (getLocal()?.Date | date:'short') + ')' : ''}}?"
                  type="button">
            Delete
            {{getLocal()?.Date ? '(' + (getLocal()?.Date | date:'short') + ')' : ''}}
          </button>
        </mat-menu>
        <div class="fill-remaining-space"></div>
        <mat-icon *ngIf="checkPackaging().length > 0" matTooltip="Individual products are not allowed!">warning</mat-icon>
        <mat-icon *ngIf="!hasReachedFranco() && !hasShippingLine()" matTooltip="This order has not reached the franco and has no shipping, please calculate the shipping!">warning</mat-icon>
        <mat-icon *ngIf="hasReachedFranco() && hasShippingLine()" matTooltip="This order has reached the franco but still has the shipping!">warning</mat-icon>
        <button *ngIf="isLoadingShipping" class="loadingbutton" mat-button type="button">
          <mat-spinner class="spinner" color="accent" diameter="18"></mat-spinner> &nbsp; Loading Shipping costs
        </button>
        <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
        <app-button [disabled]="isValid()" [isLoading]="isLoading || isLoadingShipping"
                    [matMenuTriggerFor]="saveMenu" type="button"></app-button>
        <mat-menu #saveMenu="matMenu">
          <button (click)="save({Id: '6f2ffafe-e634-450c-981d-53304a089d14', Value: 'Draft'})" [disabled]="isValid()" mat-menu-item type="button">
            Draft
          </button>
          <button (click)="save({Id: '4b78a670-de3d-4cec-980d-92ba569ef7a0', Value: 'Open'})" [disabled]="isValid()" mat-menu-item type="button">
            Open
          </button>
        </mat-menu>
      </mat-dialog-actions>
    </ng-container>
  </form>
</ng-template>

<app-visual-article-picker #articlePicker (ListChange)="Copy.addDocumentLinesByBasketLines($event); setRelation($event.relation); setDeliveryDate()" [Relation]="Copy?.Relation"></app-visual-article-picker>
<app-crm-address-editor #aEditor [List]="Copy?.Relation?.Addresses" (ListChange)="Copy.Relation.Addresses = $event"></app-crm-address-editor>
<app-crm-contact-editor #cEditor [List]="Copy?.Relation?.Contacts" (ListChange)="Copy.Relation.Contacts = $event"></app-crm-contact-editor>
<app-import-documentlines-wizard #importWizard [(Document)]="Copy" (DocumentChange)="setDeliveryDate()"></app-import-documentlines-wizard>
